
      import ThreeDimensional from './three-dimensional.vue'
      import type { App, Plugin } from 'vue'

      export const ThreeDimensionalPlugin: Plugin = {
        install(app: App) {
          app.component('ThreeDimensional', ThreeDimensional)
        },
      }
      export { ThreeDimensional }
      